export default [
  {
    path: '/order/appeal',
    name: 'appeal',
    meta: {
      index: 3
    },
    component: () => import('@/views/order/appeal.vue')
  }
]